/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does 20% off plus an extra 10% off equal 30% off?`)
};

const es_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un 20% de descuento más un 10% adicional equivale a un 30% de descuento?`)
};

const de_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergeben 20% Rabatt plus weitere 10% Rabatt zusammen 30% Rabatt?`)
};

const nl_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 20% korting plus nog eens 10% korting samen 30% korting?`)
};

const fr_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce que 20 % de réduction plus 10 % supplémentaires équivalent à 30 % de réduction ?`)
};

const it_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il 20% di sconto più un ulteriore 10% di sconto equivale al 30% di sconto?`)
};

const pt_br2_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% de desconto mais 10% de desconto extra é igual a 30% de desconto?`)
};

const pt_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% de desconto mais 10% extra é igual a 30% de desconto?`)
};

const ja_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20%オフにさらに10%オフを加えると30%オフになりますか？`)
};

const zh_pct_discount_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先减 20% 再额外减 10% 等于 30% 的折扣吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq3_q", locale)
	if (locale === "en") return en_pct_discount_faq3_q(inputs)
	if (locale === "es") return es_pct_discount_faq3_q(inputs)
	if (locale === "de") return de_pct_discount_faq3_q(inputs)
	if (locale === "nl") return nl_pct_discount_faq3_q(inputs)
	if (locale === "fr") return fr_pct_discount_faq3_q(inputs)
	if (locale === "it") return it_pct_discount_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq3_q(inputs)
	if (locale === "pt") return pt_pct_discount_faq3_q(inputs)
	if (locale === "ja") return ja_pct_discount_faq3_q(inputs)
	return zh_pct_discount_faq3_q(inputs)
};